<template>
  <div class="white-blocks catalog__in">
    <div class="catalog__in-img">
      <a :href="getCompanyLink(item.link)">
        <img
          v-if="item.image"
          :src="thumb(item.image, 300)"
          :alt="item.title"
        />
        <img v-else :src="placeholderImage" alt="no-image" />
      </a>
    </div>
    <div class="catalog__in-content">
      <div class="catalog__in-content-top">
        <div class="catalog__in-content-left">
          <a :href="getCompanyLink(item.link)" class="catalog__name">{{
            item.title
          }}</a>
          <div class="catalog__subname shop__items-subname">
            <div
              v-for="(category, index) in item.categories"
              :key="index"
              class="inline-block"
            >
              <a :href="getHrefByCategory(category)"
                >{{ category.title
                }}{{ index !== item.categories.length - 1 ? "," : "" }}</a
              >
            </div>
          </div>
          <div class="rate-wrap">
            <div class="rate">
              <rate :rating="item.rating" />
            </div>
            {{ $tc("catalog.reviews_count", item.reviews_count || 0) }}
          </div>
        </div>
        <div class="catalog__in-content-right">
          <a
            v-if="item.phones && item.phones.length"
            :href="'tel:' + item.phones[0]"
            class="catalog__tel"
            >{{ item.phones[0] }}</a
          >
          <div v-if="item.location" class="catalog__address">
            {{ item.location.address }}
          </div>
        </div>
      </div>
      <div class="catalog__in-text">
        {{ item.description !== null ? replaceComma(item.description) : "" }}
        <a :href="getCompanyLink(item.link)">{{ $t("Read more") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Rate from "../components/Rate";
import LanguageMixin from "../mixins/LanguageMixin";

export default {
  name: "Item",

  components: {
    Rate,
  },

  mixins: [LanguageMixin],

  props: {
    item: { type: Object, required: true },
  },

  computed: {
    placeholderImage() {
      return window.IMAGE_PLACEHOLDER;
    },
  },

  mounted() {
    $(this.$el).hover(() => {
      this.$emit("hovered", this.item);
    });
  },

  methods: {
    /**
     * @typedef Category
     * @property {number} id
     * @property {string} title
     *
     * @param {Category} category
     */
    getHrefByCategory(category) {
      const url = new URL(window.location.href);

      const query_string = url.search;

      const search_params = new URLSearchParams(query_string);

      // new value of "id" is set to "101"
      search_params.set("category", String(category.id));

      // change the search property of the main url
      url.search = search_params.toString();

      // the new url string
      const res = url.toString();
      //console.log(res);
      return res;
    },

    replaceComma($text) {
      return $text.replace(",", ", ");
    },

    getCompanyLink(link) {
      let langCodes = Object.keys(SUPPORT_LOCALES);
      let segments = link.split("/");

      if (this.lang && segments[1] !== "" && !langCodes.includes(segments[1])) {
        segments[0] = this.language;
        return "/" + segments.join("/");
      }

      return link;
    },
  },
};
</script>
